<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.form.procedimentos.concat(data.model.procedimentos)"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:cell(info)="row">
                <div v-if="Number.isInteger(row.item.id)">
                    <rkm-icon
                        :id="`pronto-atendimento-procedimento-info-${row.item.id}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`pronto-atendimento-procedimento-info-${row.item.id}`"
                        triggers="hover"
                    >
                        <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                        <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                        <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                    </rkm-popover>

                    {{ row.item.dataHora }}
                </div>
            </template>

            <template v-slot:cell(procedimento)="row">
                <div v-if="row.item.procedimento">
                    {{ row.item.procedimento.codigo | formatProcedimento }} - {{ row.item.procedimento.nome }}
                </div>
            </template>

            <template v-slot:cell(cidPrincipal)="row">
                <div v-if="row.item.cidPrincipal && row.item.cidPrincipal.codigo">
                    {{ row.item.cidPrincipal.codigo | formatCid }} - {{ row.item.cidPrincipal.nome }}
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="Number.isInteger(row.item.id) || row.item.procedimento.isParametrizado"
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id) || row.item.procedimento.isParametrizado"
                    @click="handleDestroy(row.item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>

            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Filters.
import formats from '@/filters/formats'

export default {
    data: () => ({
        fields: [
            { key: 'info', label: 'Data / Hora', class: 'col-min' },
            { key: 'lotacao.ocupacao.codigo', label: 'CBO' },
            { key: 'procedimento', label: 'Procedimento' },
            { key: 'cidPrincipal', label: 'CID Principal' },
            { key: 'quantidade', label: 'Quantidade' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    components: { Modal },
    filters: {
        ...formats,
    },
    methods: {
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                resolve(this.data.model.procedimentos.splice(this.data.model.procedimentos.findIndex(procedimento => procedimento.id === item.id), 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>